import React, {useEffect} from 'react';
import {useConfirmationDialog} from 'shared/components/ConfirmationDialog/ConfirmationDialog';
import {useAppContext} from 'contexts/ApplicationContext';
import {useNavigate, useLocation} from 'react-router-dom';

export const InvalidProduct = ({message}) => {
    const {dialog, showDialog, hideDialog} = useConfirmationDialog();
    const location = useLocation();
    const navigate = useNavigate();
    const {userProfile} = useAppContext();

    useEffect(() => {
        const showMessage = `
        <p>Contact support to make this product available.<p>
        <strong><p style="color:red">ERROR: ${message}</p></strong>
        <p>Support Contact Details</p>
        ${userProfile.manufacturerContactInfo}`;
        showDialog({
            title: 'Invalid Product',
            message: showMessage,
            hideYesButton: true,
            hideNoButton: true,
            buttons: [
                {
                    name: 'Ok',
                    show: true,
                    action: () => {
                        navigate(location.pathname);
                        hideDialog();
                    },
                },
            ],
        });
    }, [message]);

    return <div>{dialog}</div>;
};
